import * as angular from 'angular';
import { ComponentDefinition, GroupStepsAvailability } from '../../models';
import { StepIconDefinition } from './StepIconDefinition';

export const stepsDefinition =
{
    'acquisition': 'fa-database',
    'script': 'fa-code',
    'scriptV3': 'fa-code-fork',
    'states': 'fa-barcode',
    'reconciliation': 'fa-caret-square-o-right',
    'alarms': 'fa-bell'
};

class GroupStepsController implements angular.IComponentController {
    isLoading: boolean;
    mapped: StepIconDefinition[];
    readonly streps: any[]; //??
    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['steps'] && changesObj['steps'].currentValue) {
            this.mapped = changesObj['steps']
                .currentValue
                .map((d: GroupStepsAvailability) => {
                    const classed: { [classed: string]: boolean } = {};
                    let stepName = d.name.charAt(0).toLowerCase() + d.name.slice(1);
                    if (stepName === 'script' && d.isScriptV3) {
                        stepName = 'scriptV3';
                    }
                    const className = stepsDefinition[stepName];
                    classed[className] = !!d.available;
                    classed['inactive'] = !d.active;
                    return {
                        title: d.name.charAt(0).toUpperCase() + d.name.slice(1),
                        classed
                    };
                });
        }
    }
}

export const wtGroupSteps: ComponentDefinition = {
    componentId: 'wtGroupSteps',
    controller: GroupStepsController,
    controllerAs: 'vm',
    template: require('./groupSteps.component.html'),
    bindings: {
        steps: '<'
    }
};